'use strict';
import angular from 'angular';
import StripeRepo from './stripe.repository.js';
import StripeService from './stripe.service.js';
import NewCardModalSvc from './newCardModal/newCardModal.service.js';
import NewAccountModalSvc from './newAccountModal/newAccountModal.service.js';
import VerifyAccountModalSvc
  from './verifyAccountModal/verifyAccountModal.service.js';

export default angular.module('georgeApp.stripe', [])
  .factory('StripeRepo', StripeRepo)
  .factory('StripeSvc', StripeService)
  .factory('NewCardModalSvc', NewCardModalSvc)
  .factory('NewAccountModalSvc', NewAccountModalSvc)
  .factory('VerifyAccountModalSvc', VerifyAccountModalSvc)
  .name;
